import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_STORE_BY_ID } from "../../../../operations/queries/operations/queries/get-store-by-id.js";
import fromStoreByByIdQueryToStoreById from "../../adapters/hooks/api/adapters/fromStoreByByIdQueryToStoreById.js";
const useStoreById = (variables) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(GET_STORE_BY_ID, {
    variables,
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    },
    errorPolicy: "all",
    onError(error) {
      toast.failed("stores.page.search.getStoreById.error");
      console.error("Failed to fetch store by code: ", error);
    }
  });
  const { store } = queryState.data ?? {};
  const data = React.useMemo(() => fromStoreByByIdQueryToStoreById(store), [store]);
  return React.useMemo(() => [query, { ...queryState, data }], [data, queryState, query]);
};
export {
  useStoreById as default
};
//# sourceMappingURL=use-store-by-id.js.map
